import { AmcLambdaFetch, awaitJSON } from '@src/utils/fetch-utils';
import {
  AdvertiserInput,
  AdvertiserUpdate,
  AdvertiserUpdateResult,
  AmcInstance,
  CreateInstanceResult,
  DeleteInstanceResult,
  InstanceAdvertiser,
  InstanceInput
} from './amc-instances-types';

// Instance admin endpoints on the bpm-lambdas `amc` service. Reads are live from Amazon.
// Writes default to dryRun: true so a missed argument can't mutate a real ad account.

export const listInstances = async (): Promise<AmcInstance[]> =>
  awaitJSON<AmcInstance[]>(await AmcLambdaFetch('/listAmcInstances', { method: 'GET' }));

export const createInstance = async (
  input: InstanceInput,
  dryRun = true
): Promise<CreateInstanceResult> =>
  awaitJSON<CreateInstanceResult>(
    await AmcLambdaFetch('/createAmcInstance', {
      method: 'POST',
      body: { ...input, dryRun }
    })
  );

// instanceName is immutable after creation, so it isn't sent.
export const updateInstance = async (
  instanceId: string,
  input: Omit<InstanceInput, 'instanceName'>,
  dryRun = true
): Promise<AmcInstance> =>
  awaitJSON<AmcInstance>(
    await AmcLambdaFetch('/updateAmcInstance', {
      method: 'POST',
      body: { instanceId, ...input, dryRun }
    })
  );

export const deleteInstance = async (
  instanceId: string,
  dryRun = true
): Promise<DeleteInstanceResult> =>
  awaitJSON<DeleteInstanceResult>(
    await AmcLambdaFetch('/deleteAmcInstance', {
      method: 'POST',
      body: { instanceId, dryRun }
    })
  );

export const listInstanceAdvertisers = async (instanceId: string): Promise<InstanceAdvertiser[]> =>
  awaitJSON<InstanceAdvertiser[]>(
    await AmcLambdaFetch('/listAmcInstanceAdvertisers', {
      method: 'GET',
      params: { instanceId }
    })
  );

export const listAdvertiserUpdates = async (instanceId: string): Promise<AdvertiserUpdate[]> =>
  awaitJSON<AdvertiserUpdate[]>(
    await AmcLambdaFetch('/listAmcAdvertiserUpdates', {
      method: 'GET',
      params: { instanceId }
    })
  );

export const modifyAdvertisers = async (
  instanceId: string,
  changes: { advertisersToAdd?: AdvertiserInput[]; advertisersToRemove?: AdvertiserInput[] },
  dryRun = true
): Promise<AdvertiserUpdateResult> =>
  awaitJSON<AdvertiserUpdateResult>(
    await AmcLambdaFetch('/modifyAmcInstanceAdvertisers', {
      method: 'POST',
      body: {
        instanceId,
        advertisersToAdd: changes.advertisersToAdd ?? [],
        advertisersToRemove: changes.advertisersToRemove ?? [],
        dryRun
      }
    })
  );
